<template>
	<div class="main-menu">
		<div class="menu__content">
			<ul class="menu__list">
				<li
					v-for="item in linkList"
					:key="item.link"
					class="menu__item"
					@click="
						() => {
							moveToPage(item.link);
						}
					"
				>
					<div
						:class="
							item.link === location
								? 'item__container active'
								: 'item__container'
						"
					>
						<div class="menu__icon" :class="'menu-' + item.content"></div>
						<p class="title" v-html="item.title"></p>
					</div>
				</li>
				<!-- <li class="menu-item"></li>
                <li class="menu-item"></li> -->
			</ul>
			<ul class="menu__list">
				<li class="menu__item" @click="logOut">
					<div class="item__container">
						<div class="menu__icon menu-logout"></div>
						<p class="title">로그아웃</p>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
// import { logoutApi } from '@/api/modules/login';
import { requestGrowthplateLogout } from '@/helpers/common';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import { StudyStore } from '@/store/modules/study';
import { routerKey, useRouter } from 'vue-router';

const router = useRouter();
const globalStore = GlobalStore();
const studyStore = StudyStore();
const store = DialogStore();
const linkList = [
	{ content: 'home', title: '홈', link: '/learninghome' },
	{ content: 'report', title: '학습 분석리포트', link: '/analysisreport' },
	{ content: 'note', title: '마이노트', link: '/note' },
	{ content: 'my', title: '마이페이지', link: '/mypage' },
	// { content: 'setting', title: '설정', link: '/settings' },
];

const location = window.location.pathname;

const moveToPage = page => {
	router.push(page);
};

const logOut = () => {
	const logOutCall = v => {
		if (v) {
			console.log('logOutCall ===', v);
			console.log('globalStore loginRoot ===', globalStore.loginRoot);

			// 성장판 로그인인 경우
			if (globalStore.loginRoot === 'growthplate') {
				console.log('성장판 로그아웃');
				globalStore.setLogoutPath('HOME');
				requestGrowthplateLogout();
			} else {
				//logoutApi((rs) => {

				// logout completed
				globalStore.initStore();
				studyStore.initStore();
				globalStore.setAudience('');
				// window.location.href = `${process.env.VUE_APP_SSO_LOGOUT_URL}`;
				/*
					external-login: 외부 접근 로그인  /krt-login
					web: 체험 계정 로그인  /exp-login
					macadamia: 마카다미아 로그인  VUE_APP_SSO_LOGOUT_URL
				*/
				if (globalStore.loginRoot === 'external-login') {
					window.location.href = '/krt-login';
				} else if (globalStore.loginRoot === 'web') {
					window.location.href = '/exp-login';
				} else if (globalStore.loginRoot === 'macadamia') {
					window.location.href = process.env.VUE_APP_SSO_LOGOUT_URL;
				}
			}
		}
	};

	store.openConfirmDialog({
		message: '로그아웃 하시겠습니까?',
		cancel: '닫기',
		ok: '확인',
		callback: logOutCall,
	});
};
</script>

<style scoped lang="scss">
p {
	margin: 0;
}
.main-menu {
	flex: 0 0 auto;
	padding: 5.7vw 0 7.7vw;
	width: 10vw;
	min-width: 90px;
	max-width: 200px;
	height: calc(var(--vh, 1vh) * 100);
	min-height: 768px;
	border-right: 1px solid $color_gray_400;
	box-sizing: border-box;
}
.menu__content {
	// @include display-flex;
	// flex-direction: column;
	// justify-content: space-between;
	height: 100%;
}
.menu__list {
	width: 6.6vw;
	margin: 0 auto;
}
.menu__list:nth-of-type(2) {
	margin-top: 17.6vw;
}
.menu__item {
	cursor: pointer;
}
.menu__item:nth-of-type(n + 2) {
	margin-top: 3.7vw;
}
.menu__item .title {
	margin-top: 0.3vw;
	font-size: 0.9vw;
	color: $color_gray_600;
	line-height: 1.1vw;
	text-align: center;
}
.menu-logout + .title {
	display: none;
}
.menu {
	&__icon {
		width: 2.4vw;
		height: 2.4vw;
		margin: 0 auto;
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
	}
	&-home {
		background-image: url('@/assets/images/icon/ico_home_off.svg');
	}
	&-note {
		background-image: url('@/assets/images/icon/ico_wronganswernote_off.svg');
	}
	&-report {
		background-image: url('@/assets/images/icon/ico_review_off.svg');
	}

	&-my {
		background-image: url('@/assets/images/icon/ico_my_off.svg');
	}

	&-setting {
		background-image: url('@/assets/images/icon/ico_setting_off.svg');
	}

	&-logout {
		background-image: url('@/assets/images/icon/ico_logout_off.svg');
	}
}

.active {
	.title {
		color: #222;
	}

	.menu {
		&-home {
			background-image: url('@/assets/images/icon/ico_home_on.svg');
		}

		&-note {
			background-image: url('@/assets/images/icon/ico_wronganswernote_on.svg');
		}

		&-report {
			background-image: url('@/assets/images/icon/ico_review_on.svg');
		}

		&-my {
			background-image: url('@/assets/images/icon/ico_my_on.svg');
		}

		&-setting {
			background-image: url('@/assets/images/icon/ico_setting_on.svg');
		}

		&-logout {
			background-image: url('@/assets/images/icon/ico_logout_on.svg');
		}
	}
}

.item__container:hover {
	.title {
		color: #222;
	}

	.menu {
		&-home {
			background-image: url('@/assets/images/icon/ico_home_on.svg');
		}

		&-note {
			background-image: url('@/assets/images/icon/ico_wronganswernote_on.svg');
		}

		&-report {
			background-image: url('@/assets/images/icon/ico_review_on.svg');
		}

		&-my {
			background-image: url('@/assets/images/icon/ico_my_on.svg');
		}

		&-setting {
			background-image: url('@/assets/images/icon/ico_setting_on.svg');
		}

		&-logout {
			background-image: url('@/assets/images/icon/ico_logout_on.svg');
		}
	}
}

/*
.main-menu {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    min-width: 90px;
    width: 10vw;
    max-width: 200px;
    // width: 200px;
    height: calc((var(--vh, 1vh) * 100));
    min-height: 768px;
    // padding-top: 6.8%;
    //padding: 9.25vmin 0 3.33vmin;
    // background-color: #F2F5F7;
    border-right: 1px solid #e4e4e4;

    .title {
        margin-top: 0.5vmin;
        font-size: 0.9vw;
        color: $color_gray_600;
        text-align: center;
        line-height: 1.1vw;
    }
}

.menu-list {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 51%;
    left: auto;
    //height: 100%;
    height: 87%;
    max-height: 1035.41px;
    @include transform(translateY(-50%));
}

.menu {
    &-item-container {
        cursor: pointer;
    }

    &-item {
        justify-content: center;
        display: inline-grid;
        // height: 14.27vh;
        height: calc(100% / 7);
        align-items: center;

        .title {
            font-size: 1.2vmin;
        }
    }

    &-home,
    &-note,
    &-report,
    &-my,
    &-setting,
    &-logout {
        width: 2.4vw;
        height: 2.4vw;
        margin: 0 auto;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    &-home {
        background-image: url('@/assets/images/icon/ico_home_off.svg');
    }

    &-note {
        background-image: url('@/assets/images/icon/ico_wronganswernote_off.svg');
    }

    &-report {
        background-image: url('@/assets/images/icon/ico_review_off.svg');
    }

    &-my {
        background-image: url('@/assets/images/icon/ico_my_off.svg');
    }

    &-setting {
        background-image: url('@/assets/images/icon/ico_setting_off.svg');
    }

    &-logout {
        background-image: url('@/assets/images/icon/ico_logout_off.svg');
    }
}

.active {
    .title {
        color: #222;
    }

    .menu {
        &-home {
            background-image: url('@/assets/images/icon/ico_home_on.svg');
        }

        &-note {
            background-image: url('@/assets/images/icon/ico_wronganswernote_on.svg');
        }

        &-report {
            background-image: url('@/assets/images/icon/ico_review_on.svg');
        }

        &-my {
            background-image: url('@/assets/images/icon/ico_my_on.svg');
        }

        &-setting {
            background-image: url('@/assets/images/icon/ico_setting_on.svg');
        }

        &-logout {
            background-image: url('@/assets/images/icon/ico_logout_on.svg');
        }
    }
}

.menu-item-container:hover {
    .title {
        color: #222;
    }

    .menu {
        &-home {
            background-image: url('@/assets/images/icon/ico_home_on.svg');
        }

        &-note {
            background-image: url('@/assets/images/icon/ico_wronganswernote_on.svg');
        }

        &-report {
            background-image: url('@/assets/images/icon/ico_review_on.svg');
        }

        &-my {
            background-image: url('@/assets/images/icon/ico_my_on.svg');
        }

        &-setting {
            background-image: url('@/assets/images/icon/ico_setting_on.svg');
        }

        &-logout {
            background-image: url('@/assets/images/icon/ico_logout_on.svg');
        }
    }
}

@media screen and (min-width:$desktop_full_width + 1) {
    .menu-list {
        top: 52%;
        height: 87%;
    }
}

@include pc_size_s {
    .menu-list {
        top: 52%;
        height: 82%;
    }
}*/
@include pc_full {
	.menu__list:nth-of-type(2) {
		margin-top: 12.8vw;
	}
}
@include tablet_l {
	.menu__list:nth-of-type(2) {
		margin-top: 18.8vw;
	}
}
</style>
